import { DialogPresenterService, DialogData } from 'app/components/dialogs/dialog-presenter/dialog-presenter.service';
import { CarrierCreateDialog } from 'app/main/admin/users/dialogs/carrier/create/carrier-create-dialog.component';
import { CarrierLimitationsDialog } from 'app/main/admin/users/dialogs/carrier/limitations/carrier-limitations-dialog.component';
import { TableOperationActionType, TableOperationsHelper } from 'app/components/helpers/table-operations.helper';
import { TableOperationsFactory } from 'app/components/table-operations-controller/table-operations-controller';
import { ActionBarOperation } from 'app/components/action-bar/action-bar.component';

export class CarriersTableOperationsFactory implements TableOperationsFactory {

    constructor(
        private dialogPresenter: DialogPresenterService,
        private completion
    ) { }

    makeOperations(selected) {
        return this.makeOperationsWithSelected(selected);
    }

    makeDefaultOperation(selected) {
        return TableOperationsHelper.makeOperationWithType(
            TableOperationActionType.Edit,
            this.dialogPresenter,
            () => this.makeDialogData(),
            selected);
    }

    private makeOperationsWithSelected(selected) {
        let types = [
            TableOperationActionType.Add,
            TableOperationActionType.Edit,
            TableOperationActionType.Remove,
        ];
        let operations = TableOperationsHelper.makeOperationsWithTypes(
            types,
            this.dialogPresenter,
            () => this.makeDialogData(),
            selected,
            this.completion
        );
        operations.push(this.makeLimitationsOperation(selected));
        return operations;
    }

    private makeDialogData(): DialogData {
        return {
            dialog: CarrierCreateDialog,
            panel: 'carrier-create-dialog-container',
            data: {}
        }
    }

    private makeLimitationsOperation(selected) {
        let dialogData: DialogData = {
            dialog: CarrierLimitationsDialog,
            panel: 'carrier-limitations-dialog-container',
            data: { object: selected[0], disableClose: false }
        };
        return new ActionBarOperation({
            title: 'USERS.TABS.CARRIERS.ROWOPERATION.LIMITATIONS',
            icon: 'check_circle',
            action: () => { this.dialogPresenter.showDialog(dialogData) },
            disabled: TableOperationsHelper.notSingleSelection(selected)
        });
    }
}
